import styled from "styled-components";

export const Container = styled.div`
  .mHeader {
    .MuiTypography-h6 {
      display: flex;
      justify-content: space-between;
      .content {
        display: flex;
        flex-direction: column;
        .title {
          font-size: 1.2rem;
          font-weight: 500;
        }
        .subtitle {
          font-size: 0.8rem;
          font-weight: 300;
          color: #666;
        }
      }
    }
  }

  .mContent {
    min-height: 300px;
    padding: 16px 24px;

    a.alert-justify {
      background-color: #DDDDDD;

      &:hover {
        background-color: #DDDDDD;
      }
    }

    a.alert-justified {
      background-color: #DDDDDD;

      &:hover {
        background-color: #FFFFFF;
      }
    }
  }

  .mFooter {
    padding: 10px 24px;
  }
`;
